// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import { ErrorMessage } from "formik";
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Program Type and Delivery Type are no longer selected up front: the report
// is generated for the whole date range ("default" for both API params) and
// refined with the client-side filters above the results table.
export function CampReportForm({
  reportResults,
  setReportResults,
  setReportTypeId,
  values,
  errors,
  touched,
  setFieldValue,
}) {
  return (
    <>
      {
        <div className="form-group row">
          <div className={"col-lg-6"}>
            <label className={"required-field pr-2"}>Start Date</label>
            <OverlayTrigger overlay={<Tooltip>Camp Start Date</Tooltip>}>
              <i className="fa fa-question-circle" aria-hidden="true"></i>
            </OverlayTrigger>
            <input
              type="date"
              className={
                "form-control" +
                (errors.startdate && touched.startdate ? " is-invalid" : "")
              }
              value={values.startdate ? values.startdate.split("T")[0] : ""}
              onChange={(e) => {
                setFieldValue("startdate", e.target.value);
                if (reportResults && reportResults.length > 0) {
                  setReportResults();
                }
              }}
            ></input>
            <ErrorMessage
              name={`startdate`}
              component="div"
              className="invalid-feedback"
            />
          </div>
          <div className={"col-lg-6"}>
            <label className={"required-field pr-2"}>End Date</label>
            <OverlayTrigger overlay={<Tooltip>Camp End Date</Tooltip>}>
              <i className="fa fa-question-circle" aria-hidden="true"></i>
            </OverlayTrigger>
            <input
              type="date"
              className={
                "form-control" +
                (errors.enddate && touched.enddate ? " is-invalid" : "")
              }
              value={values.enddate ? values.enddate.split("T")[0] : ""}
              onChange={(e) => {
                setFieldValue("enddate", e.target.value);
                if (reportResults && reportResults.length > 0) {
                  setReportResults();
                }
              }}
            ></input>
            <ErrorMessage
              name={`enddate`}
              component="div"
              className="invalid-feedback"
            />
          </div>
        </div>
      }
    </>
  );
}
